export default {
    da: {
        46: '3F Superliga',
        85: '1. division',
        239: '2. division',
        256: '3F Ligaen',
        242: 'DBU Pokalen',
        47: 'Premier League',
        48: 'Championship',
        132: 'The Emirates FA Cup',
        133: 'Liga Cup',
        87: 'Primera Division',
        138: 'Copa del Rey',
        55: 'Serie A',
        141: 'Coppa Italia',
        54: 'Bundesliga',
        146: '2.Bundesliga',
        57: 'Æresdivisionen',
        53: 'Ligue 1',
        67: 'Allsvenskan',
        59: 'Tippeligaen',
        42: 'UEFA Champions League',
        73: 'UEFA Europa League',
        71: 'Tyrkiet Super Lig',
        77: 'VM (Mænd)',
        50: 'EM (Mænd)',
        76: 'VM (Kvinder)',
        292: 'EM (Kvinder)',
        489: 'Venskabskamp',
        10353: 'Venskabskamp',
        352: 'Primo Tours Ligaen',
        354: '1.division (Kvinder)',
        358: 'Op/Ned Spil (Kvinder)',
        350: 'Cup Winners Cup',
        348: 'Champions League',
        361: 'EHF Cup',
        363: 'Europamesterskab',
        387: 'Verdensmesterskab',

        367: 'Bundesliga (Kvinder)',
        372: 'Postenligaen (Kvinder)',
        383: 'Elitserien (Kvinder)',

        353: 'Boxer Mændligaen',
        355: '1.division (Mænd)',
        359: 'Op/Ned Spil (Mænd)',

        349: 'Champions League',
        362: 'EHF Cup',
        368: 'Bundesliga (Mænd)',
        364: 'Europamesterskab',
        388: 'Verdensmesterskab',
        373: 'Postenligaen (Mænd)',
        378: 'Liga Asobal',
        384: 'Elitserien (Mænd)',

        311: 'Metal Ligaen',
        24: 'NHL',
        21: 'SHL',
        9436: 'KHL',
        328: 'VM',
        33: 'VM',

        391: 'Basketligaen (Mænd)',
        390: 'NBA',
        392: 'Dameligaen (Kvinder)',

        9079: 'Badmintonligaen',

        8884: 'Volleyligaen (Mænd)',
        8883: 'Volleyligaen (Kvinder)',
    },
};



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/i18.tournaments.js
 **/